export const recommendData = [
  {
    text: 'PR TIMES STORY',
    href: '/story',
  },
  {
    text: '動画制作・動画PRならPR TIMES TV',
    href: '/tv/info_tv?utm_source=prtimes&utm_medium=footer',
  },
  {
    text: '記者発表・イベント配信ならPR TIMES LIVE',
    href: '/tv/info_live?utm_source=prtimes&utm_medium=footer',
  },
  {
    text: 'PR TIMES MAGAZINE',
    href: 'https://prtimes.com/magazine/',
  },
  {
    text: '広報PRの効果測定はWebクリッピング',
    href: '/webclipping/service/',
    isExternal: true,
  },
  {
    text: 'PR Editor',
    href: 'https://preditor.prtimes.com/?utm_source=prtimes&utm_medium=referral&utm_campaign=240606_prtimes_footer',
    isExternal: true,
  },
  {
    text: 'タスク・プロジェクト管理ならJooto',
    href: 'https://www.jooto.com/',
    isExternal: true,
  },
  {
    text: '無料フォーム・FAQならTayori',
    href: 'https://tayori.com/feature/faq',
    isExternal: true,
  },
  {
    text: 'PR事例ならPR EDGE',
    href: 'https://predge.jp/',
    isExternal: true,
  },
];
